import React from 'react'
import { useTheme } from '@mui/material'
import { DaysDisengagedIcon } from 'src/designSystem/icons'
import IndicatorChip from 'src/participantsHome/ParticipantListItem/IndicatorChip'

const INACTIVE_DAYS = 14
const DORMANT_DAYS = 21

type Props = {
  title: string
  days: number
  expanded?: boolean
}

const StalledTrackIndicator = ({ title, days, expanded = false }: Props) => {
  const { palette } = useTheme()
  const levelColor = () => {
    if (days >= DORMANT_DAYS) {
      return palette.severityHigh
    }

    return days >= INACTIVE_DAYS ? palette.severityMedium : palette.severityLow
  }
  const color = levelColor()

  return (
    <IndicatorChip
      tooltip={`${title} stalled for ${days} days`}
      label={expanded ? 'Stalled' : undefined}
      color={color}
      testId="stalled-track-indicator"
    >
      <DaysDisengagedIcon days={days} color={color} />
    </IndicatorChip>
  )
}

export default StalledTrackIndicator
